import { useState, useCallback, useRef } from "react";
import apiFetch from "../../../shared/services/apiClient";

/**
 * useCedulaLookup
 *
 * Consulta el endpoint /api/residents/cedula-lookup/?cedula=XXX
 * cuando la cédula tiene al menos 9 caracteres.
 *
 * Fuentes en orden: base local → TSE Costa Rica (público).
 *
 * Returns: { buscar, resultado, estado }
 *   estado: "idle" | "buscando" | "local" | "tse" | "no_encontrado" | "error"
 */
export function useCedulaLookup() {
  const [resultado, setResultado] = useState(null);
  const [estado, setEstado] = useState("idle");
  const lastCedula = useRef("");

  const buscar = useCallback(async (cedula) => {
    const c = cedula.replace(/\D/g, "");
    if (c.length < 9 || c === lastCedula.current) return;
    lastCedula.current = c;

    setEstado("buscando");
    setResultado(null);
    try {
      const res = await apiFetch(`/api/residents/cedula-lookup/?cedula=${c}`);
      const data = await res.json();
      if (res.ok && data.fuente !== "no_encontrado") {
        setResultado(data);
        setEstado(data.fuente); // "local" | "tse"
      } else {
        setEstado("no_encontrado");
      }
    } catch (_) {
      setEstado("error");
    }
  }, []);

  function reset() {
    setResultado(null);
    setEstado("idle");
    lastCedula.current = "";
  }

  return { buscar, resultado, estado, reset };
}
